import { X } from "lucide-react"
import { cn } from "@/lib/utils"

type AssociationTagProps = {
  label: string
  className?: string
  onRemove?: () => void
  removeLabel?: string
  disabled?: boolean
}

const AssociationTag = ({
  label,
  className,
  onRemove,
  removeLabel = "Verwijder tag",
  disabled = false,
}: AssociationTagProps) => {
  if (!label || label.trim().length === 0) {
    return null
  }

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1 rounded-md px-2 py-2 bg-primary/5 text-[11px] font-medium text-primary border border-primary/75 border-solid",
        className
      )}
    >
      <span>{label.trim()}</span>
      {onRemove ? (
        <button
          type="button"
          onClick={onRemove}
          disabled={disabled}
          className={cn(
            "ml-1 flex items-center justify-center rounded-full p-0.5 text-primary transition-colors hover:bg-primary/10 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary/50",
            disabled && "opacity-50 cursor-not-allowed hover:bg-transparent"
          )}
          aria-label={`${removeLabel} ${label.trim()}`}
        >
          <X size={12} strokeWidth={2} />
        </button>
      ) : null}
    </span>
  )
}

export default AssociationTag
